import type {
  GltfAccessorType,
  GltfComponentType,
} from '@/plugins/mesh/loaders/gltfLowMemory/types'

const COMPONENT_BYTE_SIZES: Readonly<Record<GltfComponentType, number>> = {
  5120: 1,
  5121: 1,
  5122: 2,
  5123: 2,
  5125: 4,
  5126: 4,
}

const COMPONENT_COUNTS: Readonly<Record<GltfAccessorType, number>> = {
  SCALAR: 1,
  VEC2: 2,
  VEC3: 3,
  VEC4: 4,
  MAT2: 4,
  MAT3: 9,
  MAT4: 16,
}

export function getGltfComponentByteSize(componentType: GltfComponentType): number {
  return COMPONENT_BYTE_SIZES[componentType]
}

export function getGltfComponentCount(type: GltfAccessorType): number {
  return COMPONENT_COUNTS[type]
}

export function isGltfComponentType(value: unknown): value is GltfComponentType {
  return typeof value === 'number' && Object.hasOwn(COMPONENT_BYTE_SIZES, value)
}

export function isGltfAccessorType(value: unknown): value is GltfAccessorType {
  return typeof value === 'string' && Object.hasOwn(COMPONENT_COUNTS, value)
}
